// extracted by css-extract-rspack-plugin
export default {"cls1":"useFirstSuggestedWorkToast-cls1_mT-","cls2":"useFirstSuggestedWorkToast-cls2_i6E useFirstSuggestedWorkToast-cls1_mT-"};